import Model from 'src/storage/base';

class PatientTreatmentDetailModel extends Model {
  id = 'PatientTreatmentDetailModel';
  defaultState = () => ({
    treatment: null,
    isImproved: true,
    status: 'in_process',
    improvedComment: '',
    isEffect: true,
    effectComment: '',
    files: [],
    media: []
  });

  apiConfig = {
    treatment_detail: {
      url: 'admin/treatment/detail',
      validation: {
        messageId: 'string'
      },
      cancellable: true
    }
  };

  loadDetail = (messageId, cb) => {
    this.api('treatment_detail', { messageId }, (error, treatment, success) => {
      if (success) {
        this.setState({ treatment });
      }
      cb && cb(error, treatment, success);
    });
  };
}

const model = new PatientTreatmentDetailModel();
export default model;
